import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/app/store";
import { APIResponse } from "@/types/custom-http";
import { ExternalOt, ExternalOtState } from "./external-ot.interface";
import * as thunks from "./external-otThunks";

const initialState: ExternalOtState = {
  items: [],
  selectedExternalOt: null,
  loading: false,
  error: null,
};

const externalOtSlice = createSlice({
  name: "externalOt",
  initialState,
  reducers: {
    clearExternalOt: (state) => {
      state.items = [];
    },
    clearSelectedExternalOt: (state) => {
      state.selectedExternalOt = null;
    },
    clearExternalOtError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(thunks.fetchExternalOt.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.fetchExternalOt.fulfilled, (state, action: PayloadAction<APIResponse<ExternalOt[]>>) => {
        state.loading = false;
        if (action.payload.data) {
          state.items = action.payload.data;
        }
      })
      .addCase(thunks.fetchExternalOt.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      .addCase(thunks.searchExternalOt.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.searchExternalOt.fulfilled, (state, action: PayloadAction<APIResponse<ExternalOt[]>>) => {
        state.loading = false;
        if (action.payload.data) {
          state.items = action.payload.data;
        }
      })
      .addCase(thunks.searchExternalOt.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      .addCase(thunks.fetchExternalOtById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.fetchExternalOtById.fulfilled, (state, action: PayloadAction<APIResponse<ExternalOt>>) => {
        state.loading = false;
        if (action.payload.data) {
          state.selectedExternalOt = action.payload.data;
        }
      })
      .addCase(thunks.fetchExternalOtById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      .addCase(thunks.updateExternalOt.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.updateExternalOt.fulfilled, (state, action: PayloadAction<APIResponse<ExternalOt>>) => {
        state.loading = false;
        const index = state.items.findIndex((item) => item.id === action.payload.data?.id);
        if (index !== -1 && action.payload.data) {
          state.items[index] = action.payload.data;
        }
        if (state.selectedExternalOt && state.selectedExternalOt.id === action.payload.data?.id) {
          state.selectedExternalOt = action.payload.data;
        }
      })
      .addCase(thunks.updateExternalOt.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      });
  },
});

export const selectAllExternalOt = (state: RootState) => state.externalOt.items;
export const selectExternalOtById = (state: RootState, id: number) =>
  state.externalOt.items.find((item) => item.id === id);
export const selectSelectedExternalOt = (state: RootState) => state.externalOt.selectedExternalOt;
export const selectExternalOtLoading = (state: RootState) => state.externalOt.loading;
export const selectExternalOtError = (state: RootState) => state.externalOt.error;

export const { clearExternalOt, clearSelectedExternalOt, clearExternalOtError } = externalOtSlice.actions;

export default externalOtSlice.reducer;
